import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay", "backdrop"];

  connect() {
    this.checkMobile();
    this.handleResize = this.checkMobile.bind(this);
    window.addEventListener("resize", this.handleResize);
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize);
  }

  checkMobile() {
    this.isMobile = window.innerWidth < 768;
  }

  toggle() {
    if (!this.isMobile) return;

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.toggle("translate-y-full");
      this.overlayTarget.classList.toggle("translate-y-0");
    }

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.toggle("hidden");
    }
  }

  open() {
    if (!this.isMobile) return;

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("translate-y-full");
      this.overlayTarget.classList.add("translate-y-0");
    }

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden");
    }
  }

  close() {
    if (!this.isMobile) return;

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("translate-y-full");
      this.overlayTarget.classList.remove("translate-y-0");
    }

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden");
    }
  }
}
